
import React, { Component } from 'react';
import "@arco-design/web-react/dist/css/arco.css";
import { Form,Input, Layout, Menu, Space, Card, Carousel,Button,Typography,Modal  } from '@arco-design/web-react';

import * as utils from "../utils.js"
import ScaledImage from '../comp/my-img';

export default class MyComp extends Component{
  constructor(props) {
    super(props);
    this.state = {
      winWidth: 0,
      winHeight: 100,
    }

    this.handleResize = this.handleResize.bind(this);
  }

  componentDidMount(){
    window.addEventListener('resize', this.handleResize);
    this.handleResize()
    window.scrollTo(0, 0);
  }
  componentWillUnmount(){
    window.removeEventListener('resize', this.handleResize);
  }
  handleResize(e){
    let winWidth  = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    let winHeight  = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    // winWidth = winWidth - 30
    // winHeight = winHeight - 80

    this.setState({
      winWidth: winWidth,
      winHeight: winHeight,
    })
  }
  getCompany1(){
    let {winWidth} = this.state
    if(winWidth == 0){
      return
    }

    let idx = 1
    let rate = winWidth/2027
    let tipHeight = 1338*rate
    let tipWidth = 1269*rate

    let {language} = this.props
    let languageFolder = utils.GetLanguageFolder(language)

    let urlbg = `../imgs/img_banner${idx}.png`
    let url_txt1 = `../imgs/img_tip${idx}_1.png`
    let url_txt2 = `../imgs/img_tip${idx}_2.png`
    let url_txt3 = `../imgs/${languageFolder}img_tip${idx}_3.png`
    let url_txt4 = `../imgs/${languageFolder}img_tip${idx}_4.png`


    return (<div style={{width: '100vw', height:tipHeight}} onClick={()=>{
      this.props.history.push({
        pathname:'/musichall',
        state: []
      })
    }}>
      <div style={{position:'relative', }}>
      <img src={urlbg} style={{width: '100vw', aspectRatio:'auto', position:'absolute', left: 0, top: 0,}} />
      <Space direction='vertical' style={{height: tipHeight*0.88, position:'absolute', right: '5vw', top: 0, alignItems:'flex-end', justifyContent:'flex-end'}}>
        <ScaledImage src={url_txt1} rate={rate}></ScaledImage>
        <ScaledImage src={url_txt2} rate={rate}></ScaledImage>
        <Space direction='horizontal' >
          {/* <ScaledImage src={url_txt3} rate={rate} onClick={()=>{
            this.props.history.push({
              pathname:'/page2',
              state: []
            })
          }}></ScaledImage> */}
          <ScaledImage src={url_txt4} rate={rate}></ScaledImage>
        </Space>
      </Space>
      </div>
    </div>
    )
  }
  getCompany2(){
    let {winWidth} = this.state
    if(winWidth == 0){
      return
    }
    let idx = 2
    let rate = winWidth/2027
    let tipHeight = 1338*rate
    let tipWidth = 1269*rate
    let urlbg = `../imgs/img_banner${idx}_0.png`


    let {language} = this.props
    let languageFolder = utils.GetLanguageFolder(language)

    let url_txt1 = `../imgs/${languageFolder}img_tip${idx}_1.png`
    let url_txt2 = `../imgs/${languageFolder}img_tip${idx}_2.png`
    let url_txt3 = `../imgs/${languageFolder}img_tip${idx}_3.png`
    let url_txt4 = `../imgs/${languageFolder}img_tip${idx}_4.png`
 
    if(language == 'de' || language == 'en'){
      return (<div style={{width: '100vw', height:tipHeight}} onClick={()=>{
        this.props.history.push({
          pathname:'/page2',
          state: []
        })
      }}>
        <div style={{position:'relative', }}>
        <img src={urlbg} style={{width: '100vw', aspectRatio:'auto', position:'absolute', left: 0, top: 0,}} />
        <Space direction='vertical' align='baseline' style={{height: tipHeight*0.88, position:'absolute', right: '5vw', top: 0, alignItems:'flex-end', justifyContent:'flex-end'}}>
          <ScaledImage src={url_txt1} rate={rate}></ScaledImage>
  
        </Space>
        </div>
      </div>
      )
    }
    return (<div style={{width: '100vw', height:tipHeight}} onClick={()=>{
      this.props.history.push({
        pathname:'/page2',
        state: []
      })
    }}>
      <div style={{position:'relative', }}>
      <img src={urlbg} style={{width: '100vw', aspectRatio:'auto', position:'absolute', left: 0, top: 0,}} />
      <Space direction='vertical' align='baseline' style={{height: tipHeight*0.88, position:'absolute', right: '5vw', top: 0, alignItems:'flex-end', justifyContent:'flex-end'}}>
        <ScaledImage src={url_txt1} rate={rate}></ScaledImage>
        <ScaledImage src={url_txt2} rate={rate}></ScaledImage>

      </Space>
      </div>
    </div>
    )
  }
  getCompany3(){
    let {winWidth} = this.state
    if(winWidth == 0){
      return
    }
    let idx = 3
    let rate = winWidth/2027
    let tipHeight = 1338*rate
    let tipWidth = 1269*rate

    let {language} = this.props
    let languageFolder = utils.GetLanguageFolder(language)


    let urlbg = `../imgs/img_banner${idx}_0.png`
    let url_txt1 = `../imgs/${languageFolder}img_tip${idx}_1.png`
    let url_txt2 = `../imgs/${languageFolder}img_tip${idx}_2.png`
    let url_txt3 = `../imgs/${languageFolder}img_tip${idx}_3.png`
    let url_txt4 = `../imgs/${languageFolder}img_tip${idx}_4.png`

    if(language == 'de' || language == 'en'){
      return (<div style={{ width: '100vw', height:tipHeight}} onClick={()=>{
        this.props.history.push({
          pathname:'/page3',
          state: []
        })
      }}>
        <div style={{position:'relative', }}>
        <img src={urlbg} style={{width: '100vw', aspectRatio:'auto', position:'absolute', left: 0, top: 0,}} />
        <Space direction='vertical' align='baseline' style={{height: tipHeight*0.88, position:'absolute', left: '5vw', top: 0, alignItems:'flex-start', justifyContent:'flex-end'}}>
          <ScaledImage src={url_txt1} rate={rate}></ScaledImage>
        </Space>
         </div>
      </div>
      )
    }

    return (<div style={{ width: '100vw', height:tipHeight}} onClick={()=>{
      this.props.history.push({
        pathname:'/page3',
        state: []
      })
    }}>
      <div style={{position:'relative', }}>
      <img src={urlbg} style={{width: '100vw', aspectRatio:'auto', position:'absolute', left: 0, top: 0,}} />
      <Space direction='vertical' align='baseline' style={{height: tipHeight*0.88, position:'absolute', left: '5vw', top: 0, alignItems:'flex-start', justifyContent:'flex-end'}}>
        <ScaledImage src={url_txt1} rate={rate}></ScaledImage>
      </Space>
      <Space direction='vertical' align='baseline' style={{height: tipHeight*0.71, position:'absolute', left: '48vw', top: 0, alignItems:'flex-start', justifyContent:'flex-end'}}>
        <ScaledImage src={url_txt2} rate={rate}></ScaledImage>
      </Space>
      </div>
    </div>
    )
  }
  render() {
    return (
      <div >
        {this.getBody()}
      </div>
    );
  }
}

